// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.iframe-wrap[data-v-a3b7cc18]{display: flex;flex-wrap: wrap}\niframe[data-v-a3b7cc18] {width: calc(50% - 4px);    height: calc(50vh - 4px);    border: 2px solid #000;}\n", ""]);
// Exports
module.exports = exports;
